/** @jsx jsx */

import React, { Fragment as _, useContext, ReactElement } from 'react';
import { css, jsx } from '@emotion/core';
import { interactionContext as _interactionContext } from './interactionContext';

interface ResultsPageMediaProps {
  children: ReactElement[] | ReactElement | string | null;
}

const ResultsPageMedia = (props: ResultsPageMediaProps) => {
  const interactionContext = useContext(_interactionContext);

  const {
    id: interactionContextId,
    displayPassFailContent,
    passed,
  } = interactionContext;

  const { showImage = true } = interactionContext.props;

  const { children } = props as any;

  return showImage
    ? window.dev()
      ? children[displayPassFailContent === 'passed' ? 0 : 1]
      : children[passed ? 0 : 1]
    : null;
};

export default ResultsPageMedia;
